export default __webpack_public_path__ + "static/media/AnalyticsIcon.ddd113b8.svg";